import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { StoreProvider } from './store';
import { LanguageProvider } from './i18n';
import './styles.css';

createRoot(document.getElementById('root')!).render(<StrictMode><LanguageProvider><StoreProvider><App/></StoreProvider></LanguageProvider></StrictMode>);
